import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function TrimPatternValidator(pattern: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value: string = control.value;
    const regExp = new RegExp(pattern);

    if (value) {
      return regExp.test(value.trim()) ? null : { pattern: true };
    }

    return null;
  };
}
